/**
 * 展会详情 legacy URL：客户端路由切换 301 兜底
 * SSR 首屏由 server/middleware/00-exhibitionDetailLegacyRedirect.ts 处理，此处仅 CSR 导航
 */

/** 将 route.query 转为 ?key=value 字符串，供 301 location 拼接 */
function legacySearchFromRouteQuery(query: Record<string, unknown>): string {
  const qs = new URLSearchParams()
  for (const [k, v] of Object.entries(query)) {
    if (v == null) continue
    if (Array.isArray(v)) v.forEach(item => qs.append(k, String(item)))
    else qs.set(k, String(v))
  }
  const s = qs.toString()
  return s ? `?${s}` : ''
}

export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return

  const search = legacySearchFromRouteQuery(to.query as Record<string, unknown>)
  const { resolveLegacyExhibitionDetailRedirectLocation } = await import(
    '~/utils/exhibitionDetailLegacyRedirect'
  )
  const location = await resolveLegacyExhibitionDetailRedirectLocation(
    to.path,
    search,
    to.hash || '',
  )
  if (!location) return

  const current = `${to.path}${search}${to.hash || ''}`
  if (location === current) return

  return navigateTo(location, { redirectCode: 301, external: true })
})
